export default __webpack_public_path__ + "static/media/hudlFormatGuide.dc7014c8.svg";